export default {"src":"/_next/static/media/49-icon.551056f1.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};